import React from 'react'
import { RecoilRoot } from 'recoil'
import IntlWrapper from './src/i18n/IntlWrapper'
import CookieBanner from './src/components/CookieBanner'

export const wrapPageElement = ({ element, props }) => (
  <RecoilRoot {...props}>
    <IntlWrapper>
      {element}
      <CookieBanner />
    </IntlWrapper>
  </RecoilRoot>
)
